import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trim } from 'lodash';
import SectionTitle from '@src/components/SectionTitle';
import Checkbox from '@src/components/Checkbox';
import { TextField } from '@src/components/TextField';
import { OpeningCandidateDestinationTypeEnum } from '@src/graphql/generated';
import './styles.scss';

export default function CandidateDestination({ candidateDestination, onFieldChange }) {
  const onToggleCandidateDestination = type => {
    onFieldChange({ candidateDestination: { type } });
  };

  const onCandidateDestinationUrlChange = url => {
    onFieldChange({
      candidateDestination: {
        type: OpeningCandidateDestinationTypeEnum.EXTERNAL_URL,
        url: trim(url),
      },
    });
  };

  return (
    <div className="candidate-destination">
      <SectionTitle
        size="M"
        subtitle="Choose where potential candidates will be directed."
        title="How would you like to receive your applicants?"
      />

      <Fragment>
        <Checkbox
          label="Applicants apply through an external website"
          onChange={() => onToggleCandidateDestination(OpeningCandidateDestinationTypeEnum.EXTERNAL_URL)}
          value={candidateDestination.type === OpeningCandidateDestinationTypeEnum.EXTERNAL_URL}
          wrapperClassName="candidate-destination__external-url-checkbox"
        />
        <TextField
          defaultValue={candidateDestination.url}
          label="External application url*"
          onChange={url => onCandidateDestinationUrlChange(url)}
          wrapperClassName="candidate-destination__external-url-input"
        />
      </Fragment>

      <div className="candidate-destination__meetfrank-wrapper">
        <Checkbox
          label="Let applicants apply through MeetFrank"
          onChange={() => onToggleCandidateDestination(OpeningCandidateDestinationTypeEnum.MEETFRANK)}
          value={candidateDestination.type === OpeningCandidateDestinationTypeEnum.MEETFRANK}
        />
      </div>
    </div>
  );
}

CandidateDestination.propTypes = {
  candidateDestination: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};
